import { useEffect, useState } from 'react'
import to from 'await-catch'
import { getPatientAppointments } from '../api'
import { addFlashMessage } from '../actions'

const inFlightAppointmentsByPatientId = {}

export const useUpcomingAppointments = ({ patientId, dispatch, limit = 4 }) => {
	const [todayAppointments, setTodayAppointments] = useState([])
	const [allUpcomingAppointments, setAllUpcomingAppointments] = useState([])
	const [upcomingAppointments, setUpcomingAppointments] = useState([])

	useEffect(() => {
		if (!patientId) {
			setTodayAppointments([])
			setAllUpcomingAppointments([])
			setUpcomingAppointments([])
			return
		}

		let isMounted = true

		if (!inFlightAppointmentsByPatientId[patientId]) {
			inFlightAppointmentsByPatientId[patientId] = to(getPatientAppointments(patientId)).finally(
				() => {
					delete inFlightAppointmentsByPatientId[patientId]
				}
			)
		}

		const fetchAppointments = async () => {
			try {
				const [err, { data } = {}] = await inFlightAppointmentsByPatientId[patientId]
				if (err) {
					throw err
				}

				const sorted = (data || []).sort(
					(a, b) => new Date(a.fechaTurnoDateTime) - new Date(b.fechaTurnoDateTime)
				)

				const now = new Date()
				const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate())
				const todayEnd = new Date(
					now.getFullYear(),
					now.getMonth(),
					now.getDate(),
					23,
					59,
					59
				)

				const today = []
				const upcoming = []

				sorted.forEach(app => {
					const date = new Date(app.fechaTurnoDateTime)

					if (date >= todayStart && date <= todayEnd) {
						today.push(app)
					} else if (date > todayEnd) {
						upcoming.push(app)
					}
				})

				const nextAppointments = upcoming.slice(0, limit)
				if (!isMounted) return
				setTodayAppointments(today)
				setAllUpcomingAppointments(upcoming)
				setUpcomingAppointments(nextAppointments)
			} catch (error) {
				if (!isMounted) return
				dispatch(addFlashMessage('Ocurrió un error cargando los turnos'))
			}
		}

		fetchAppointments()

		return () => {
			isMounted = false
		}
	}, [dispatch, limit, patientId])

	return { todayAppointments, allUpcomingAppointments, upcomingAppointments }
}